import styled from 'styled-components';


export const MainWrapper = styled.main`
  flex: 1 1 auto;
`